import {
  PLATFORM_ORG_CHART,
  PLATFORM_CALENDAR,
  PLATFORM_TIME_OFF,
  PLATFORM_FULL_TIME_EQUIVALENT,
  PLATFORM_SICKNESS_REPORTING,
} from '@ApplicationWide/permissions/constants';

export const SURVEYS_SETTINGS = 'surveys';
export const APPROVAL_SETTINGS = 'approvals';
const ONBOARDING_PLAN = 'onboarding';

// eslint-disable-next-line complexity
const checkCompanySettingsConditionals = (area, company) => {
  if (area === PLATFORM_CALENDAR && !company.baseDetails?.enabledCalendar) {
    return Boolean(company.baseDetails?.enabledCalendar);
  }
  if (area === PLATFORM_ORG_CHART) {
    return Boolean(company.baseDetails?.enabledOrgChart);
  }
  if (area === PLATFORM_TIME_OFF && !company.baseDetails?.enabledTimeOff) {
    return Boolean(company.baseDetails?.enabledTimeOff);
  }
  if (area === SURVEYS_SETTINGS) {
    return Boolean(company.baseDetails?.surveysEnabled);
  }
  if (area === APPROVAL_SETTINGS) {
    return Boolean(company.defaultProfileDetails?.enableCustomTableApprovalEngine);
  }
  if (area === PLATFORM_FULL_TIME_EQUIVALENT) {
    return Boolean(
      company.baseDetails?.workingPatternsFeatureFlag || company.baseDetails?.workingPatternsAdminFeatureFlag,
    );
  }
  if (area === PLATFORM_SICKNESS_REPORTING) {
    return Boolean(
      company.baseDetails?.absenceManagementFeatureFlag || company.baseDetails?.absenceManagementAdminFeatureFlag,
    );
  }
  return true;
};

export const isCompanySettingsEnabled = (area, company) => {
  if (!company) return true;
  return checkCompanySettingsConditionals(area, company);
};

export const isCompanyPlanOnboarding = (company) => company?.baseDetails.companyPlan === ONBOARDING_PLAN;
